import { Component, EventEmitter, Output, Input } from '@angular/core';

@Component({
  selector: 'assessors-relaunch-popup',
  templateUrl: './assessors-relaunch-popup.component.html',
  styleUrls: ['./assessors-relaunch-popup.component.less',  '../../shared/common.less']
})
export class AssessorsRelaunchPopupComponent {
  @Output() isClosed = new EventEmitter<boolean>();
  @Input() isResend = true;
  @Input() isAssessors = false;

  onDismiss(event: boolean) {
    this.isClosed.emit(event);
  }
}
